import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { Modal } from "../../components/modal";
import {
  OrganizationForm,
  OrganizationFormValues,
} from "../../components/organization-form";
import { useAdditionalFields } from "../../hooks/addition-fields";
import { parseFormValuesToAdditionalFields } from "../../services/additional-fields";
import { createOrganization } from "../../services/organization";
import { navigateBack } from "../../utils/navigate-back";

export function OrganizationCreate() {
  const navigate = useNavigate();
  const { data: additionalFields } = useAdditionalFields("organization");
  const queryClient = useQueryClient();

  const [loading, setLoading] = useState(false);
  const [hasError, setHasError] = useState(false);

  const [formValues, setFormValues] = useState<OrganizationFormValues>({
    corporateRegistrationNumber: "",
    name: "",
    email: "",
    phone: "",
    additionalFields: additionalFields.reduce(
      (acc, field) => ({
        ...acc,
        [field.name]: "",
      }),
      {},
    ),
  });

  const closeModal = () => {
    navigateBack(navigate, "/admin/register/organization");
  };

  return (
    <Modal open onClose={() => closeModal()}>
      <OrganizationForm
        hasError={hasError}
        loading={loading}
        values={formValues}
        onCancel={() => closeModal()}
        onChange={setFormValues}
        onSubmit={() => {
          (async () => {
            setLoading(true);
            try {
              await createOrganization({
                corporateRegistrationNumber:
                  formValues.corporateRegistrationNumber,
                name: formValues.name,
                email: formValues.email,
                phone: formValues.phone,
                ...(formValues.additionalFields && {
                  additionalData: parseFormValuesToAdditionalFields(
                    formValues.additionalFields,
                    additionalFields,
                  ),
                }),
              });
              await queryClient.invalidateQueries({
                queryKey: ["organizations"],
              });
              closeModal();
            } catch (error: unknown) {
              setHasError(true);
            } finally {
              setLoading(false);
            }
          })();
        }}
      />
    </Modal>
  );
}
